// The SAP Ship Doc guide (36_SapShipDoc.jsx · ModuleHelp, Max 01/11).
const en = {
  stepsT: 'The steps, left to right',
  stepsB: 'Source shows the Master Sheet rows against SAP. Steps 2 to 4 settle the SFP line, the ITEM line and the quantity split; Destination words the destination column; Document is the finished table. The badge counts what is left to check, and any step can be opened in any order.',
  metaT: 'Rows and last read',
  metaB: 'How many rows are on screen, and when the document last read SAP. If it says not read yet, run Sync from SAP first.',
  quarterT: 'The date window',
  quarterB: 'Pick a quarter or type a from and to date. Every step and the document read this window.',
  toolsT: 'Check, export and sync',
  toolsB: 'Check changes lists what moved since the last time. Excel downloads the table as one file or one per vendor. Sync from SAP (if you may) re-reads SAP now; the arrow reloads the screen.',
  tableT: 'The document',
  tableB: 'One row per shipment line, with the SAP codes and quantities. Click a header to sort or filter; the Σ rows at the foot give the totals, and Checking flags rows that look duplicated.',
};
const ko = {
  stepsT: '왼쪽에서 오른쪽으로 진행하는 단계',
  stepsB: '원천은 Master Sheet 행을 SAP와 대조합니다. 2~4단계는 SFP 라인, ITEM 라인, 수량 분할을 정하고, 목적지는 목적지 열 표기를 정하며, 문서는 완성된 표입니다. 배지는 남은 확인 건수이며, 단계는 순서와 관계없이 열 수 있습니다.',
  metaT: '행 수와 마지막 읽기',
  metaB: '화면에 보이는 행 수와 문서가 SAP를 마지막으로 읽은 시점입니다. 아직 읽지 않았다고 나오면 먼저 SAP에서 동기화를 실행하세요.',
  quarterT: '기간 범위',
  quarterB: '분기를 고르거나 시작일과 종료일을 입력하세요. 모든 단계와 문서가 이 기간을 기준으로 읽습니다.',
  toolsT: '점검, 내보내기, 동기화',
  toolsB: '변경 점검은 지난번 이후 바뀐 내용을 보여 줍니다. Excel은 표를 한 파일 또는 업체별 파일로 내려받습니다. SAP에서 동기화(권한이 있을 때)는 지금 SAP를 다시 읽고, 화살표는 화면을 새로고침합니다.',
  tableT: '문서 표',
  tableB: '출하 라인당 한 행이며 SAP 코드와 수량이 들어 있습니다. 머리글을 클릭해 정렬·필터하고, 아래 Σ 행이 합계이며, Checking 열은 중복처럼 보이는 행을 표시합니다.',
};
const vi = {
  stepsT: 'Các bước, từ trái sang phải',
  stepsB: 'Source đối chiếu các dòng Master Sheet với SAP. Bước 2 đến 4 chốt dòng SFP, dòng ITEM và cách chia số lượng; Destination quy định cách ghi cột điểm đến; Document là bảng hoàn chỉnh. Huy hiệu là số dòng còn phải kiểm, và bạn mở bước nào trước cũng được.',
  metaT: 'Số dòng và lần đọc gần nhất',
  metaB: 'Số dòng đang hiện và lần cuối tài liệu đọc SAP. Nếu ghi chưa đọc lần nào, hãy chạy Sync from SAP trước.',
  quarterT: 'Khoảng ngày',
  quarterB: 'Chọn một quý hoặc nhập ngày từ và đến. Mọi bước và tài liệu đều đọc theo khoảng này.',
  toolsT: 'Kiểm tra, xuất và đồng bộ',
  toolsB: 'Check changes liệt kê những gì đã đổi kể từ lần trước. Excel tải bảng về thành một file hoặc mỗi vendor một file. Sync from SAP (nếu bạn có quyền) đọc lại SAP ngay; mũi tên tải lại màn hình.',
  tableT: 'Bảng tài liệu',
  tableB: 'Mỗi dòng giao hàng một hàng, kèm mã SAP và số lượng. Bấm tiêu đề để sắp xếp hoặc lọc; các dòng Σ ở cuối là tổng, cột Checking đánh dấu các dòng có vẻ bị trùng.',
};
const zh = {
  stepsT: '从左到右的步骤',
  stepsB: 'Source 把 Master Sheet 的行与 SAP 对照。第 2 到 4 步确定 SFP 行、ITEM 行和数量拆分；Destination 决定目的地列的写法；Document 是最终表格。角标是还需检查的数量，各步骤可按任意顺序打开。',
  metaT: '行数与最近读取',
  metaB: '屏幕上的行数，以及文档最近一次读取 SAP 的时间。如果显示尚未读取，请先执行 Sync from SAP。',
  quarterT: '日期范围',
  quarterB: '选择一个季度，或输入起止日期。所有步骤和文档都按这个范围读取。',
  toolsT: '检查、导出与同步',
  toolsB: 'Check changes 列出自上次以来的变化。Excel 可把表下载成一个文件，或按供应商分开下载。Sync from SAP（需有权限）会立即重新读取 SAP；箭头按钮刷新页面。',
  tableT: '文档表格',
  tableB: '每条出货行一行，含 SAP 编码和数量。点击表头可排序或筛选；底部的 Σ 行是合计，Checking 列会标出看起来重复的行。',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "stepsT": "Les étapes, de gauche à droite",
  "stepsB": "Source présente les lignes du Master Sheet face à SAP. Les étapes 2 à 4 règlent la ligne SFP, la ligne ITEM et la répartition des quantités ; Destination formule la colonne de destination ; Document est le tableau final. Le badge compte ce qui reste à vérifier, et chaque étape peut être ouverte dans n'importe quel ordre.",
  "metaT": "Lignes et dernière lecture",
  "metaB": "Combien de lignes sont à l'écran, et quand le document a lu SAP pour la dernière fois. S'il indique pas encore lu, lancez d'abord Synchroniser depuis SAP.",
  "quarterT": "La fenêtre de dates",
  "quarterB": "Choisissez un trimestre ou saisissez une date de début et de fin. Chaque étape et le document lisent cette fenêtre.",
  "toolsT": "Contrôler, exporter et synchroniser",
  "toolsB": "Vérifier les modifications liste ce qui a bougé depuis la dernière fois. Excel télécharge le tableau en un seul fichier ou un fichier par fournisseur. Synchroniser depuis SAP (si vous en avez le droit) relit SAP maintenant ; la flèche recharge l'écran.",
  "tableT": "Le document",
  "tableB": "Une ligne par ligne d'expédition, avec les codes SAP et les quantités. Cliquez sur un en-tête pour trier ou filtrer ; les lignes Σ en bas donnent les totaux, et Contrôle signale les lignes qui semblent en doublon."
};
const ja = {
  "stepsT": "ステップ（左から右）",
  "stepsB": "「ソース」は Master Sheet の行を SAP と照合して表示します。ステップ2〜4で SFP 行、ITEM 行、数量の分割を確定し、「届け先」は納入先の列の表記を整え、「ドキュメント」は完成した表です。バッジは確認が必要な残りの件数で、ステップはどの順番でも開けます。",
  "metaT": "行数と最終読み込み",
  "metaB": "画面に表示されている行数と、ドキュメントが最後に SAP を読み込んだ日時です。「未読み込み」と表示されている場合は、先に「SAPから同期」を実行してください。",
  "quarterT": "日付の範囲",
  "quarterB": "四半期を選ぶか、開始日と終了日を入力します。すべてのステップとドキュメントが、この範囲を読み込みます。",
  "toolsT": "チェック、エクスポート、同期",
  "toolsB": "「変更を確認」は前回から変わった内容を一覧表示します。Excel は表を1ファイル、または仕入先ごとに1ファイルでダウンロードします。「SAPから同期」（権限がある場合）は SAP をすぐに読み直し、矢印は画面を再読み込みします。",
  "tableT": "ドキュメント",
  "tableB": "出荷明細ごとに1行で、SAP コードと数量を表示します。見出しをクリックして並べ替えや絞り込みを行います。下部の Σ の行は合計で、「チェック」は重複しているように見える行に印を付けます。"
};

const dictionary = { ns: 'tourShipDoc', en, ko, vi, zh, fr, ja };
export default dictionary;
